import { ExclamationCircleFilled } from '@ant-design/icons';
import { Popover } from 'antd';
import React, { FC } from 'react';
import styles from './label-with-tooltip.module.less';

const LabelWithToolTip: FC<{ label: string; tooltip: string }> = ({ label, tooltip }) => {
	return (
		<>
			<span className="ant-form-item-label">{label}</span>

			<Popover title={null} trigger="click" content={tooltip} placement="bottom">
				<ExclamationCircleFilled className={styles.iconRequire} />
			</Popover>
		</>
	);
};

export default LabelWithToolTip;
